<template>
  <div class="poster-first" v-if="visibleStatus">
    <div class="poster-pop">
      <div class="wrap">
        <img src="@assets/images/poster-close.png" class="close" @click="posterImageClose" />
        <p class="phoneTitle">绑定手机号</p>
        <div class="mulBox">
          <label class="lableLeft">手机号：</label>
          <input type="number" class="inputRight" placeholder="填写手机号码" v-model="phone" />
        </div>
        <!-- <div class="mulBox">
        <label class="lableLeft">图形验证码：</label>
        <input type="text" class="inputRight imgVerifyInput" placeholder="填写图形验证码">
        <img src="@assets/images/brass.jpg" class="imgCode">
        </div>-->
        <div class="mulBox rel">
          <label class="lableLeft">短信验证码：</label>
          <input type="text" class="inputRight" placeholder="填写短信验证码" v-model="captcha" maxlength="6"/>
          <button
            class="getVerifyCode abs"
            :disabled="disabled"
            :class="disabled === true ? 'on' : ''"
            @click="code"
          >{{ text }}</button>
        </div>
        <!-- <div class="mulBox rel" v-if="isShowCode">
        <label class="lableLeft">图形验证码：</label>
        <input 
          type="text" 
          class="inputRight imgVerifyInput" 
          placeholder="填写图形验证码" 
          v-model="codeVal"
        />
        <div class="codeVal" @click="again">
          <img class="imgCode" :src="codeUrl" />
        </div>
        </div>-->
        <div class="btnBox">
          <button class="confirmBind" @click="confirm">确认绑定</button>
        </div>
      </div>
    </div>
    <div class="mask maskPhone"></div>
  </div>
</template> 
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { registerVerifyNew, bindingPhoneNew, getCodeApi } from "@api/user";
import { VUE_APP_API_URL } from "@utils";

export default {
  name: "BindPhone",
  props: {
    visibleStatus: Boolean
  },
  data: function() {
    return {
      visibleStatus: false,
      captcha: "",
      phone: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
      disabled: false,
      text: "获取验证码"
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  watch: {
    visibleStatus: function() {
      let that = this;
      if (that.visibleStatus === true) {
        // 未绑定手机号弹窗出现
      } else {
        // 已绑定手机号
        that.phone = "";
        that.captcha = "";
        that.keyCode = "";
        that.codeUrl = "";
        that.codeVal = "";
        that.clearRun(); //清空定时器
      }
    }
  },
  mounted: function() {
    this.getCode();
  },
  methods: {
    posterImageClose: function() {
      this.visibleStatus = false;
      this.$emit("setVisibleStatus");
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL + "/captcha?" + this.keyCode + Date.parse(new Date());
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    async confirm() {
      let that = this;
      const { phone, captcha, codeVal } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message("手机号码")),
              alpha_num(alpha_num.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            codeVal: this.isShowCode
              ? [
                  required(required.message("验证码")),
                  attrs.length(4, attrs.length.message("验证码")),
                  alpha_num(alpha_num.message("验证码"))
                ]
              : []
          })
          .validate({ phone, captcha, codeVal });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      bindingPhoneNew({
        phone: this.phone,
        captcha: this.captcha,
        code: this.codeVal
      })
        .then(res => {
          if (res.data !== undefined && res.data.is_bind) {
            that.$dialog.confirm({
              mes: res.msg,
              opts: [
                {
                  txt: "确认绑定",
                  color: false,
                  callback: () => {
                    bindingPhoneNew({
                      phone: this.phone,
                      captcha: this.captcha,
                      step: 1
                    })
                      .then(res => {
                        that.$dialog.success(res.msg).then(() => {
                          //绑定成功
                          that.visibleStatus = true;
                          that.$emit("setVisibleStatus");
                          location.reload();
                        });
                      })
                      .catch(res => {
                        that.$dialog.error(res.msg).then(() => {
                          //绑定失败
                        });
                      });
                  }
                },
                {
                  txt: "取消",
                  color: false,
                  callback: () => {
                    that.$dialog.error("已取消绑定").then(() => {
                      //已取消绑定
                    });
                  }
                }
              ]
            });
          } else {
            that.$dialog.success(res.msg).then(() => {
              if (res.status == 200) {
                //绑定成功
                that.visibleStatus = true;
                that.$emit("setVisibleStatus");
                location.reload();
              } else {
              }
            });
          }
        })
        .catch(res => {
          if (res.data.msg == "此手机已经绑定，无法多次绑定！") {
            //此手机已经绑定，无法多次绑定！
            that.phone = "";
            that.captcha = "";
            that.keyCode = "";
            that.codeUrl = "";
            that.codeVal = "";
            that.clearRun(); //清空定时器
          }
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      const { phone } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      registerVerifyNew({ phone: phone, key: that.keyCode, code: that.codeVal })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 400) {
          } //发送验证码次数达到上限 ｜｜60秒内有效

          if (res.data.status === 401) {
          } //发送验证码失败（key 不存在或是其他原因，导致发送失败 ）

          if (res.data.status === 402) {
            //状态值为402 会出现图形验证码
            // that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            // that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script> 
<style scoped>
.poster-first .mask {
  z-index: 1001 !important;
}
.rel {
  position: relative;
}
.abs {
  position: absolute;
}
.wrap {
  position: fixed;
  left: 50%;
  top: 50%;
  background: #fff;
  padding: 0 6% 20px;
  border-radius: 5px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  color: #333;
  z-index: 1999;
  width: 89%;
}
.maskPhone {
  z-index: 1998;
}
.close {
  width: 0.46rem;
  height: 0.75rem;
  position: fixed;
  right: 0;
  top: -0.75rem;
  display: block;
}
.mulBox {
  overflow: hidden;
  width: 100%;
  height: 36px;
  margin-bottom: 17px;
}
.lableLeft {
  width: 30%;
  float: left;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  white-space: nowrap;
}
.imgVerifyInput {
  width: 39% !important;
  float: left !important;
}
.imgCode {
  width: 24%;
  height: 36px;
  background-size: 100% 100%;
  float: right;
}
.inputRight {
  width: 70%;
  border: 1px solid #ccc;
  float: right;
  height: 36px;
  border-radius: 4px;
  padding: 5px 8px;
  font-size: 12px;
}
.phoneTitle {
  width: 100%;
  text-align: center;
  line-height: 60px;
  margin-bottom: 10px;
  font-size: 17px;
}
.btnBox {
  text-align: center;
  padding-top: 15px;
}
.confirmBind {
  width: 100%;
  height: 40px;
  background: #ff2358;
  border-radius: 20px;
  color: #fff;
  font-size: 12px;
}
.getVerifyCode {
  top: 1px;
  right: 1px;
  color: #ff2358;
  font-size: 12px;
  padding: 10px;
}
.codeVal {
  float: right;
  width: 80px;
  height: 34px;
  display: inline-block;
}
.codeVal img {
  width: 100%;
  height: 100%;
}
</style>